var _style, _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "RSSicon",
    viewBox: "0 0 8 8",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RSS feed icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .button {stroke: none; fill: orange;}\n    .symbol {stroke: none; fill: white;}\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "button",
    width: 8,
    height: 8,
    rx: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "symbol",
    cx: 2,
    cy: 6,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "m 1,4 a 3,3 0 0 1 3,3 h 1 a 4,4 0 0 0 -4,-4 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "m 1,2 a 5,5 0 0 1 5,5 h 1 a 6,6 0 0 0 -6,-6 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.f8cc78b51b66500067bf6590ade89d83.svg";
export { ForwardRef as ReactComponent };